import { IconButton } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';

type CustomerNavBackButtonProps = {
  onBackClick: () => void;
};

export const CustomerNavBackButton: React.FC<CustomerNavBackButtonProps> = ({ onBackClick }) => (
  <IconButton
    sx={{ borderRadius: '5px', padding: '8px', height: '32px', width: '32px' }}
    onClick={onBackClick}
  >
    <VyIcon icon="ArrowRight" style={{ transform: 'scaleX(-1)', color: '#323232' }} />
  </IconButton>
);
